import SharedManagementScreen from "../../shared/management/managementScreen";
import { configs } from "./definitions";
import { getSectionProvider } from "./sections/registry";

const platformDefinition = {
  id: "platform",
  defaultSection: "accounts",
  tabs: [
    { label: "Accounts", value: "accounts" },
    { label: "Users", value: "users" },
    { label: "Quickbooks", value: "quickbooks" },
    { label: "Reports", value: "reports" },
  ],
};

function getPlatformManagementDefinition() {
  return platformDefinition;
}

const platformCogMenuItems = [
  { label: "Accounts", path: "/account-management" },
  { label: "Account Listing", path: "/clients" },
  { label: "Admin Tools", path: "/admin-tools" },
  { label: "CoA", path: "/chart-of-accounts-template" },
  { label: "Client Dashboard", path: "/growth-plan" },
  { label: "Quality Control", path: "/quality-control-reviews" },
  { label: "Users", path: "/users" },
  { label: "Vendors", path: "/vendors" },
];

export default function ManagementScreen({ experience = "platform" }) {
  return (
    <SharedManagementScreen
      definition={getPlatformManagementDefinition()}
      sectionConfigs={configs}
      sectionProviderResolver={getSectionProvider}
      cogMenuItems={platformCogMenuItems}
      experience={experience}
    />
  );
}
